import script from "./scene-price-scene-picker-modal.vue?vue&type=script&lang=tsx&setup=true"
export * from "./scene-price-scene-picker-modal.vue?vue&type=script&lang=tsx&setup=true"

import "./scene-price-scene-picker-modal.vue?vue&type=style&index=0&id=6519d80c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6519d80c"]])

export default __exports__